<!-- <div [class.errorClass]="errorMessage" *ngIf="errorMessage !== null">
{{errorMessage}}</div> -->

@if (errorMessage !== null) {
<p class="help is-danger">{{ errorMessage }}</p>
}
